const hoverDelay = 400

class GemGuide extends HTMLElement {
  constructor() {
    super()

    this.wrapper = this.closest('.gem-guide')
    this.triggerItems = this.querySelectorAll('.gem-guide__item')
    this.backgroundWrapper = this.wrapper.querySelector('.gem-guide__background')

    this.init(window.innerWidth)
  }

  init(windowWidth) {
    const main = this
    function initializeListener() {
      if (windowWidth < 768) {
        main.mobileClickListener()
      } else {
        main.hoverListener()
        main.clickShowOverlay()
      }
    }

    initializeListener()
    window.addEventListener('resize', () => {
      initializeListener()
    })
  }

  clickShowOverlay() {
    this.triggerItems.forEach((trigger) => {
      trigger.querySelector('.gem-guide__item-trigger').addEventListener('click', () => {
        if (!trigger.classList.contains('activeDrawer')){
          return
        }

        const triggerHandle = trigger.querySelector('.gem-guide__item-trigger').dataset.trigger
        const gemOverlay = document.querySelector(`overlay-gem[data-overlay=${triggerHandle}]`)

        gemOverlay.classList.add('visible')
        document.querySelector(".gem-guide__background video").style.display = "none"
        document.querySelector(".altNav").style.display = "none"
        document.querySelector(".gem-guide__background .video-container").style.backgroundColor = "#000"
      })
    })
  }

  hoverListener() {
    const main = this
    let mouseenterTimer
    let mouseleaveTimer

    this.triggerItems.forEach((trigger) => {
      trigger.querySelector('.gem-guide__item-trigger').addEventListener('mouseenter', () => {
        const triggerHandle = trigger.querySelector('.gem-guide__item-trigger').dataset.trigger
        const backgroundGroup = this.backgroundWrapper.querySelector(`[data-block=${triggerHandle}]`)
        const contentWrapper = trigger.querySelector('.gem-guide__item-action')
        const gemWrapper = document.querySelector('gem-nav')

        mouseenterTimer = setTimeout(function(){
          main.swapBackgroundImages(false, backgroundGroup)
          trigger.classList.add('activeDrawer')
          gemWrapper.classList.add('drawerOpened')
          contentWrapper.classList.add('open')
        }, hoverDelay)
      })
      trigger.addEventListener('mouseleave', () => {
        clearTimeout(mouseenterTimer)

        const openDrawers = trigger.querySelectorAll('.gem-guide__item-action.open')
        const gemWrapper = document.querySelector('gem-nav')

        if (!openDrawers.length) {
          return
        }

        mouseleaveTimer = setTimeout(function(){
          main.swapBackgroundImages(true)
          openDrawers.forEach(openDrawer => openDrawer.classList.remove('open'))

          if (gemWrapper.classList.contains('drawerOpened')) {
            gemWrapper.classList.remove('drawerOpened')
          }

          if (trigger.classList.contains('activeDrawer')) {
            trigger.classList.remove('activeDrawer')
          }
        }, hoverDelay)

      })
    })
  }

  mobileClickListener() {
    const main = this
    let activeItemIndex = null

    this.triggerItems.forEach((trigger, triggerIndex) => {
      trigger.querySelector('.gem-guide__item-trigger').addEventListener('click', () => {
        // show overlay
        const allOverlays = document.querySelectorAll("overlay-gem")
        allOverlays[triggerIndex].classList.add('visible')
        document.querySelector(".gem-guide__background video").style.display = "none"
        document.querySelector(".altNav").style.display = "none"
        document.querySelector(".gem-guide__background .video-container").style.backgroundColor = "#000"
        document.querySelector(".inactive-background.active-background").classList.remove("active-background")
        document.querySelector("gem-nav").classList.remove("drawerOpened")
        document.querySelector(".gem-guide__item.activeDrawer").classList.remove("activeDrawer")
        document.querySelector(".gem-guide__item-action.open").classList.remove("open")
        activeItemIndex = null
      })
    })
  }

  mobileClickOpenListener() {
    const main = this
    let activeItemIndex = null

    this.triggerItems.forEach((trigger, triggerIndex) => {
      trigger.querySelector('.gem-guide__item-trigger').addEventListener('click', () => {
        // if clicked drawer already open, show overlay
        if (activeItemIndex === triggerIndex) {
          const allOverlays = document.querySelectorAll("overlay-gem")
          allOverlays[triggerIndex].classList.add('visible')
          document.querySelector(".gem-guide__background video").style.display = "none"
          document.querySelector(".altNav").style.display = "none"
          document.querySelector(".gem-guide__background .video-container").style.backgroundColor = "#000"
          document.querySelector(".inactive-background.active-background").classList.remove("active-background")
          document.querySelector("gem-nav").classList.remove("drawerOpened")
          document.querySelector(".gem-guide__item.activeDrawer").classList.remove("activeDrawer")
          document.querySelector(".gem-guide__item-action.open").classList.remove("open")
          activeItemIndex = null
        } else {
          const triggerHandle = trigger.querySelector('.gem-guide__item-trigger').dataset.trigger
          const backgroundGroup = this.backgroundWrapper.querySelector(`[data-block=${triggerHandle}]`)

          // close any existing open drawers
          const allItems = document.querySelectorAll('.gem-guide__item')
          allItems.forEach((item, itemIndex) => {
            item.classList.remove("activeDrawer")
            item.querySelector('.gem-guide__item-action').classList.remove("open")
          })

          // open current drawer
          const newBg = document.querySelectorAll('.inactive-background')[triggerIndex]
          const oldBg = document.querySelector(`.inactive-background.active-background:not([data-block=${triggerHandle}])`)
          newBg.classList.add('active-background')
          if (oldBg) {
            oldBg.classList.add('currently-hiding')
            setTimeout(function() {
              oldBg.classList.remove('active-background', 'currently-hiding')
            }, 800)
          }
          trigger.classList.add('activeDrawer')
          activeItemIndex = triggerIndex
          document.querySelector('gem-nav').classList.add('drawerOpened')
          trigger.querySelector('.gem-guide__item-action').classList.add('open')
        }
      })
    })
  }

  swapBackgroundImages(showDefault, bgElement = null) {
    const activeBackground = document.querySelector('.inactive-background.active-background')
    if (showDefault) {
      activeBackground.classList.add('currently-hiding')

      setTimeout(function(){
        activeBackground.classList.remove('active-background', 'currently-hiding')
      }, .08)

    } else {
      bgElement.classList.add('active-background')
      bgElement.classList.remove('visually-hidden')
    }
  }
}

customElements.define('gem-nav', GemGuide)
